import angular from 'angular'
import { AndroidHuePreviewComponent } from './android-hue-preview.component';
import { ColorPreviewComponent } from './color-preview.component';

export const ColorModule = angular
    .module("apex.common.color", [])
    .component("apexAndroidHuePreview", AndroidHuePreviewComponent)
    .component("apexColorPreview", ColorPreviewComponent)
    .name
